'use client';

import React from 'react';
import Login from '@/components/organisms/authentication/login';
import useAccount from '@/lib/hooks/useAccount';
import { AuthLayoutProps } from '@/components/organisms/authentication/types';
import { TasticProps } from '../../types';
import useCustomRouter from '@/hooks/useCustomRouter';

const publicPages = [
  'privacy',
  'warranty',
  'terms-of-use',
  'disclaimer',
  'collection-statement'
];

const AccountLoginTastic = ({ data }: TasticProps<AuthLayoutProps>) => {
  const { login, loggedIn, account, requestPasswordReset } = useAccount();
  const status = account?.onboarding_workflow_status;
  const router = useCustomRouter();
  const pathname = typeof window !== 'undefined' ? window.location.pathname : '';
  const isPublicPage = publicPages.some(page => pathname.includes(page));
  if (loggedIn && status !== 'MemberRegistered' && !isPublicPage) {
    router.push('/create-profile');
    // } else if (loggedIn && status === 'MemberRegistered') {
    //   router.push(`/`);
  }

  return <Login login={login} requestPasswordReset={requestPasswordReset} {...data} />;
};

export default AccountLoginTastic;
